
import React from 'react';
import './Footer.scss'; 
import logo from './images/kuesb_logo_gray.png'; 

function Footer() {
  return (
    <footer className="Footer">

      <section className='sec-logo'>
        {/* <img src={logo} alt="Logo" /> */}
      </section>
    

      <section className="sec-content">
          <article className="art-content">
              <p>
                  업체명 : 에이아이케이에듀(AI K-EDU) &nbsp;
                  대표 : 심규선 &nbsp;
                  개인정보보호책임자 : 심규선 &nbsp;
                  주소 : 강원특별자치도 원주시 영랑길 14-52층
              </p>
          </article>

          <article className="art-section">
            <p>
              사업자번호 : 393-51-01015 &nbsp;
              통신판매업신고 :     &nbsp;
              대표번호 : 010-9682-8801
              이메일 : gtathe17th@naver.com
            </p>
          </article>

      </section>
    </footer>
  );
}

export default React.memo(Footer);
